export const NAME = 'specials';